import { TableHeading } from "../../../components/common/table/TableDesign";
import { ARCHIEVED_REASON } from "./logReasonList";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const usaStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const ukStates = [
  "Bedfordshire",
  "Berkshire",
  "Bristol",
  "Buckinghamshire",
  "Cambridgeshire",
  "Cheshire",
  "City of London",
  "Cornwall",
  "Cumbria",
  "Derbyshire",
  "Devon",
  "Dorset",
  "Durham",
  "East Riding of Yorkshire",
  "East Sussex",
  "Essex",
  "Gloucestershire",
  "Greater London",
  "Greater Manchester",
  "Hampshire",
  "Herefordshire",
  "Hertfordshire",
  "Isle of Wight",
  "Kent",
  "Lancashire",
  "Leicestershire",
  "Lincolnshire",
  "Merseyside",
  "Norfolk",
  "North Yorkshire",
  "Northamptonshire",
  "Northumberland",
  "Nottinghamshire",
  "Oxfordshire",
  "Rutland",
  "Shropshire",
  "Somerset",
  "South Yorkshire",
  "Staffordshire",
  "Suffolk",
  "Surrey",
  "Tyne and Wear",
  "Warwickshire",
  "West Midlands",
  "West Sussex",
  "West Yorkshire",
  "Wiltshire",
  "Worcestershire",
];

export const walesStates = [
  "Anglesey",
  "Blaenau Gwent",
  "Bridgend",
  "Caerphilly",
  "Cardiff",
  "Carmarthenshire",
  "Ceredigion",
  "Conwy",
  "Denbighshire",
  "Flintshire",
  "Gwynedd",
  "Merthyr Tydfil",
  "Monmouthshire",
  "Neath Port Talbot",
  "Newport",
  "Pembrokeshire",
  "Powys",
  "Rhondda Cynon Taf",
  "Swansea",
  "Torfaen",
  "Vale of Glamorgan",
  "Wrexham",
];

export const scotlandStates = [
  "Aberdeen City",
  "Aberdeenshire",
  "Angus",
  "Argyll and Bute",
  "Clackmannanshire",
  "Dumfries and Galloway",
  "Dundee City",
  "East Ayrshire",
  "East Dunbartonshire",
  "East Lothian",
  "East Renfrewshire",
  "Edinburgh, City of",
  "Falkirk",
  "Fife",
  "Glasgow City",
  "Highland",
  "Inverclyde",
  "Midlothian",
  "Moray",
  "Na h-Eileanan Siar",
  "North Ayrshire",
  "North Lanarkshire",
  "Orkney Islands",
  "Perth and Kinross",
  "Renfrewshire",
  "Scottish Borders",
  "Shetland Islands",
  "South Ayrshire",
  "South Lanarkshire",
  "Stirling",
  "West Dunbartonshire",
  "West Lothian",
  "Western Isles",
];

export const leadCustomerAllFields = [
  {
    id: "name",
    label: "Name",
    placeHolder: "Enter full name",
    type: "text",
    isRequired: true,
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    editReadOnly: false,
  },
  {
    id: "referrerId",
    label: "Referrer",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
    isRequired: true,
  },
  {
    id: "phone",
    label: "Mobile Number",
    placeHolder: "Enter phone number",
    type: "contact",
    md: 4,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },

   {
    id: "email",
    label: "Email",
    placeHolder: "Enter email ID",
    type: "text",
    md: 4,
    isRequired: true,
  },
  {
    id: "movingOnDate",
    label: "Moving On",
    placeHolder: "Select",
    type: "daterangebothvalue",
    md: 4,
    disablePast: true,
  },
    {
     id: "alternate_phone",
    label: "Alternate Mobile Number",
    placeHolder: "Enter alternate phone number",
    type: "contact",
    md: 4,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "followUpDate",
    label: "Follow Up",
    placeHolder: "Select",
    type: "date",
    md: 2.5,
    disablePast: true,
  },
  {
    id: "followUpEndDate",
    label: "\u00A0",
    placeHolder: "Select",
    type: "timerange",
    disablePast: true,
    md: 3,
  },
   {
    id: "lead_type_id",
    label: "Lead Type",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
   {
    id: "moveType",
    label: "Lead Type",
    placeHolder: "Select",
    type: "select",
    options: ["Commercial", "Residential", "International"],
    md: 3,
    professionalOnly:false,
  },
  {
    id: "advert_id",
    label: "Advert ID",
    placeHolder: "Enter Advert ID",
    type: "text",
    md: 2.5,
    professionalOnly:true,
    // isRequired: true,
  },
  
  {
    id: "promo_code",
    label: "Promotion",
    placeHolder: "Enter Promotion",
    type: "text",
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
  {
    id: "promo_source",
    label: "Promo Source",
    placeHolder: "Enter Promo Source",
    type: "text",
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
   {
    id: "sales_person_id",
    label: "Sales Person",
    // placeHolder: "Enter Sales Person",
    type: "select",
    options:[],
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
 
   {
    id: "isAccount",
    label: "Account",
    placeHolder: "Select",
    type: "radio",
    md: 3,
    professionalOnly:true,
    options: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  },
  {
    id: "account_name",
    label: "Account Name",
    placeHolder: "Enter Account Name",
    type: "suggestionText",
    md: 3,
    professionalOnly:true,
    // isRequired: true,
  },
  {
    id: "prefix",
    label: "Prefix",
    placeHolder: "Enter Prefix",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 3,
    },
    professionalOnly:true,
    // isRequired: true,
  },
];

export const northernIrelandStates = [
  "Antrim and Newtownabbey",
  "Ards and North Down",
  "Armagh City, Banbridge and Craigavon",
  "Belfast",
  "Causeway Coast and Glens",
  "Derry City and Strabane",
  "Fermanagh and Omagh",
  "Lisburn and Castlereagh",
  "Mid and East Antrim",
  "Mid Ulster",
  "Newry, Mourne and Down",
];

export const leadCountryOptions = [
  "Australia",
  "Canada",
  "Denmark",
  "Dubai",
  "England",
  "France",
  "India",
  "Ireland",
  "Netherlands",
  "New Zealand",
  "Northern Ireland",
  "Portugal",
  "Scotland",
  "Spain",
  "USA",
  "Wales",
];

const irelandCounties = [
  "Cork",
  "Donegal",
  "Dublin",
  "Galway",
  "Kerry",
  "Kilkenny",
  "Limerick",
  "Mayo",
  "Waterford",
  "Wexford",
];

const spainProvinces = [
  "Alicante",
  "Barcelona",
  "Bilbao",
  "Granada",
  "Madrid",
  "Malaga",
  "Murcia",
  "Seville",
  "Valencia",
  "Zaragoza",
];

const denmarkRegions = [
  "Capital Region",
  "Central Denmark",
  "North Denmark",
  "Region of Southern Denmark",
  "Region Zealand",
];

const franceRegions = [
  "Auvergne-Rhone-Alpes",
  "Brittany",
  "Grand Est",
  "Hauts-de-France",
  "Ile-de-France",
  "Normandy",
  "Nouvelle-Aquitaine",
  "Occitanie",
  "Pays de la Loire",
  "Provence-Alpes-Cote d'Azur",
];

const netherlandsProvinces = [
  "Friesland",
  "Gelderland",
  "Groningen",
  "Limburg",
  "North Brabant",
  "North Holland",
  "Overijssel",
  "South Holland",
  "Utrecht",
  "Zeeland",
];

const portugalDistricts = [
  "Aveiro",
  "Braga",
  "Coimbra",
  "Faro",
  "Leiria",
  "Lisbon",
  "Madeira",
  "Porto",
  "Setubal",
  "Viseu",
];

const usStates = [
  "California",
  "Florida",
  "Georgia",
  "Illinois",
  "Massachusetts",
  "New York",
  "Ohio",
  "Pennsylvania",
  "Texas",
  "Washington",
];

const newZealandRegions = [
  "Auckland",
  "Bay of Plenty",
  "Canterbury",
  "Hawke's Bay",
  "Nelson",
  "Northland",
  "Otago",
  "Taranaki",
  "Waikato",
  "Wellington",
];

const australiaStates = [
  "Australian Capital Territory",
  "New South Wales",
  "Northern Territory",
  "Queensland",
  "South Australia",
  "Tasmania",
  "Victoria",
  "Western Australia",
];

const canadaProvinces = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
];

const dubaiEmirates = [
  "Abu Dhabi",
  "Ajman",
  "Dubai",
  "Fujairah",
  "Ras Al Khaimah",
  "Sharjah",
  "Umm Al Quwain",
];

export const getCountyOptionsByCountry = (country: string) => {
  const countyOptionsMap: Record<string, string[]> = {
    India: usaStates,
    England: ukStates,
    Wales: walesStates,
    Scotland: scotlandStates,
    "Northern Ireland": northernIrelandStates,
    Ireland: irelandCounties,
    Spain: spainProvinces,
    Denmark: denmarkRegions,
    France: franceRegions,
    Netherlands: netherlandsProvinces,
    Portugal: portugalDistricts,
    USA: usStates,
    "New Zealand": newZealandRegions,
    Australia: australiaStates,
    Canada: canadaProvinces,
    Dubai: dubaiEmirates,
  };

  return countyOptionsMap[country] || [];
};

export const leadCollectionAllFields = [
  // {
  //   id: "building_number",
  //   label: "Building No",
  //   placeHolder: "Enter building number",
  //   type: "text",
  //   // inputProps: {
  //   //   maxLength: 8,
  //   // },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  //   md: 2.5,
  // },
  {
    id: "street",
    label: "Address",
    placeHolder: "Enter street",
    type: "text",
    inputProps: {
      maxLength: 300,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
 
  {
    id: "country",
    label: "Country",
    placeHolder: "Select",
    type: "select",
    options: leadCountryOptions,
    md: 3,
  },
  {
    id: "county",
    label: "County",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
  },
   {
    id: "postcode",
    label: "Post Code",
    placeHolder: "Enter postcode",
    type: "text",
    inputProps: {
      maxLength: 8,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "town",
    label: "Town",
    placeHolder: "Enter town",
    type: "text",
    md: 3,
  },
  {
    id: "purchaseStatus",
    label: "Purchase Status",
    tooltipText: "Purchase Status",
    placeHolder: "Select",
    type: "select",
    options: [
      "Unknown",
      "Renting",
      "No Chain",
      "Standard",
      "Has Keys",
      // "Rent",
      "Owned",
      "Lease",
      "Other",
    ],
    md: 3,
  },
  {
    id: "houseSize",
    label: "Bedrooms",
    placeHolder: "Enter bedrooms",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    md: 3,
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "volume",
    label: "Volume",
    placeHolder: "Enter volume",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "volumeUnit",
    label: "Unit",
    placeHolder: "Select",
    type: "select",
    options: ["m3", "ft3"],
    md: 3,
    // width: "140px",
  },
  {
    id: "type",
    label: "Property Type",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
    // width: "140px",
  },
  {
    id: "distance",
    label: "Distance (Miles)",
    placeHolder: "Enter distance",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.NUMERIC,
    editReadOnly: true,
  },
];

export const leadDeliveryAllFields = [
  // {
  //   id: "building_number",
  //   label: "Building No",
  //   placeHolder: "Enter building number",
  //   type: "text",
  //   // inputProps: {
  //   //   maxLength: 8,
  //   // },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  //   md: 2.5,
  // },
  {
    id: "street",
    label: "Address",
    placeHolder: "Enter street",
    type: "text",
    inputProps: {
      maxLength: 300,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 12,
  },
 
  {
    id: "country",
    label: "Country",
    placeHolder: "Select",
    type: "select",
    options: leadCountryOptions,
    md: 3,
  },
  {
    id: "county",
    label: "County",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
  },
   {
    id: "postcode",
    label: "Post Code",
    placeHolder: "Enter postcode",
    type: "text",
    inputProps: {
      maxLength: 8,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "town",
    label: "Town",
    placeHolder: "Enter town",
    type: "text",
    md: 3,
  },
  {
    id: "purchaseStatus",
    label: "Purchase Status",
    tooltipText: "Purchase Status",
    placeHolder: "Select",
    type: "select",
    options: [
      "Unknown",
      "Renting",
      "No Chain",
      "Standard",
      "Has Keys",
      // "Rent",
      "Owned",
      "Lease",
      "Other",
    ],
    md: 3,
  },
  {
    id: "houseSize",
    label: "Bedrooms",
    placeHolder: "Enter bedrooms",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    md: 3,
    patternAllowed: patternConstant?.NUMERIC,
  },
   {
    id: "type",
    label: "Property Type",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 3,
  },
  // {
  //   id: "deliveryVolume",
  //   label: "Volume",
  //   placeHolder: "Enter volume",
  //   type: "text",
  //   md: 2.5,
  //   inputProps: {
  //     maxLength: 6,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
  // {
  //   id: "deliveryVolumeUnit",
  //   label: "Unit",
  //   placeHolder: "Select",
  //   type: "select",
  //   options: ["m3", "ft3"],
  //   md: 2.5,
  //   // width: "140px",
  // },
  // {
  //   id: "deliveryDistance",
  //   label: "Distance (Miles)",
  //   placeHolder: "Enter distance",
  //   type: "text",
  //   md: 2.5,
  //   inputProps: {
  //     maxLength: 6,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  //   editReadOnly: true,
  // },
  {
    id: "totalDistance",
    label: "Total Distance (Miles)",
    placeHolder: "0",
    type: "text",
    readonly: true,
    inputProps: {
      maxLength: 50,
    },
    md: 3,
  },
  // {
  //   id: "moveType",
  //   label: "Type of Move",
  //   placeHolder: "Select",
  //   type: "select",
  //   options: ["Commercial", "Residential", "International"],
  //   md: 3,
  // },
  //   {
  //   id: "moveType",
  //   label: "Type of Move",
  //   placeHolder: "Select",
  //   type: "radio",
  //   row: true,
  //   md: 6,
  //   radioOptions: [
  //     {
  //       label: "Commercial",
  //       value: "Commercial",
  //     },
  //     {
  //       label: "Residential",
  //       value: "Residential",
  //     },
  //     {
  //       label: "International",
  //       value: "International",
  //     },
  //   ],
  // },
];

export const leadCustomerNotesFields = [
  {
    id: "customerNotes",
    label: "",
    placeHolder: "Enter notes",
    type: "text",
    inputProps: {
      maxLength: 250,
    },
    md: 10.5,
  },
];

export const leadReleventFields = [
  {
    id: "movingOnDate",
    label: "Moving On",
    placeHolder: "Select",
    type: "daterangebothvalue",
    disablePast: true,
    md: 12,
  },
  {
    id: "packingOnDate",
    label: "Packing Start",
    placeHolder: "Select",
    type: "date",
    disablePast: true,
    md: 12,
  },
  {
    id: "followUpDate",
    label: "Follow Up",
    placeHolder: "Select",
    type: "date",
    disablePast: true,
    md: 6,
  },
  {
    id: "followUpEndDate",
    label: "\u00A0",
    placeHolder: "Select",
    type: "timerange",
    disablePast: true,
    md: 6,
  },
];

export const leadDetailsFormData = [
  // {
  //   id: "collection_building_number",
  //   label: "Building No.",
  //   placeHolder: "Enter building number",
  //   type: "text",
  //   md: 2.5,
  // },
  {
    id: "street",
    label: "Address",
    placeHolder: "Enter address",
    type: "viewField",
    md: 12,
  },
  {
    id: "town",
    label: "Town",
    placeHolder: "Enter town",
    type: "viewField",
    md: 3,
  },
  {
    id: "postcode",
    label: "Post Code",
    placeHolder: "Enter postcode",
    type: "viewField",
    md: 3,
  },
  {
    id: "country",
    label: "Country",
    placeHolder: "Select",
    type: "viewField",
    // options: ["England", "Wales", "Scotland", "Northern Ireland", "India"],
    md: 3,
  },
  {
    id: "county",
    label: "County",
    placeHolder: "Select",
    type: "viewField",
    // options: [],
    md: 3,
  },

  {
    id: "purchase_status",
    label: "Purchase Status",
    tooltipText: "Purchase Status",
    placeHolder: "Select",
    type: "viewField",
    // options: [
    //   "Unknown",
    //   "Renting",
    //   "No Chain",
    //   "Standard",
    //   "Has Keys",
    //   "Rent",
    //   "Owned",
    //   "Lease",
    //   "Other",
    // ],
    md: 3,
  },
  {
    id: "house_size",
    label: "Bedrooms",
    placeHolder: "Select",
    type: "viewField",
    md: 3,
  },
  {
    id: "volume",
    label: "Volume",
    placeHolder: "Enter volume",
    type: "viewField",
    md: 3,
  },
  {
    id: "volume_unit",
    label: "Unit",
    placeHolder: "Select",
    type: "viewField",
    // options: ["m3", "ft3"],
    md: 3,
    // width: "140px",
  },
  {
    id: "distance",
    label: "Distance (Miles)",
    placeHolder: "Enter distance",
    type: "viewField",
    md: 3,
  },
];
export const leadDeliveryDetailsFormData = [
  // {
  //   id: "delivery_building_number",
  //   label: "Building No.",
  //   placeHolder: "Enter building number",
  //   type: "text",
  //   md: 2.5,
  // },
  // {
  //   id: "",
  //   label: "Delivery",
  //   md: 12,
  //   type: "title",
  //   placeHolder: "",
  // },
  {
    id: "street",
    label: "Address",
    placeHolder: "Enter address",
    type: "viewField",
    md: 12,
  },
  {
    id: "town",
    label: "Town",
    placeHolder: "Enter town",
    type: "viewField",

    md: 3,
  },
  {
    id: "postcode",
    label: "Post Code",
    placeHolder: "Enter post code",
    type: "viewField",

    md: 3,
  },
  {
    id: "country",
    label: "Country",
    placeHolder: "Select",
    type: "viewField",
    //  options: ["England", "Wales", "Scotland", "Northern Ireland", "India"],
    md: 3,
  },
  {
    id: "county",
    label: "County",
    placeHolder: "Select",
    type: "viewField",
    // options: [],
    md: 3,
  },

  {
    id: "purchase_status",
    label: "Purchase Status",
    tooltipText: "Purchase Status",
    placeHolder: "Select",
    type: "viewField",
    // options: [
    //   "Unknown",
    //   "Renting",
    //   "No Chain",
    //   "Standard",
    //   "Has Keys",
    //   "Rent",
    //   "Owned",
    //   "Lease",
    //   "Other",
    // ],
    md: 3,
  },
  {
    id: "house_size",
    label: "Bedrooms",
    placeHolder: "Select",
    type: "viewField",

    md: 3,
  },
  // {
  //   id: "delivery_volume",
  //   label: "Volume",
  //   placeHolder: "Enter volume",
  //   type: "text",
  //   md: 2.5,
  //   inputProps: {
  //     maxLength: 6,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  // },
  // {
  //   id: "delivery_volume_unit",
  //   label: "Unit",
  //   placeHolder: "Select",
  //   type: "select",
  //   options: ["m3", "ft3"],
  //   md: 2.5,
  //   // width: "140px",
  // },
  {
    id: "returning_distance",
    label: "Total Distance (Miles)",
    placeHolder: "",
    type: "viewField",
    md: 2.5,
  },
];
export const filterFields = [
  {
    id: "orderBy",
    label: "Order By",
    placeHolder: "Type of Date",
    type: "select",
    options: [
      "Follow-up date",
      "Entry date",
      "Moving date",
      "Last update date",
    ],
    md: 12,
  },
  {
    id: "orderIn",
    label: "Sort By",
    placeHolder: "Sort by",
    type: "select",
    options: ["Ascending", "Descending"],
    md: 12,
  },
  {
    id: "accountName",
    label: "Account Name",
    placeHolder: "Enter account name",
    type: "select",
    options:[],
    md: 12,
  },
  {
    id: "salesPersonId",
    label: "Sales Person",
    placeHolder: "Enter sales person",
    type: "select",
    options:[],
    md: 12,
  },
];

export const leadCardDetailsFields = [
  {
    title: "Customer Details",
    isEdit: true,
    // isLogo:true,
    name: "Unknown",
    phone: "Phone Number",
    email: "EMail",
  },
  {
    title: "Relevant Dates",
    followUp: "",
    packingOn: "",
    movingOn: "",
  },
  {
    title: "Referrer",
    // isLogo:true,
    name: "Unknown",
  },
];

export const leadEstimateServiceNameFields = [
  {
    id: "serviceName",
    label: "Service Name",
    placeHolder: "Select",
    type: "select",
    md: 10,
  },
];

/*----------------------------*/
/* Estimate Screen */
/*----------------------------*/
export const leadChargesHeading: TableHeading[] = [
  { label: "Service" },
  { label: "Service Description", align: "left" },
  { label: "Provisional Date", align: "left" },
  { label: "Price", align: "center" },
  { label: "Drivers" },
  { label: "Porters", align: "left" },
  { label: "Packers", align: "left" },
  { label: "Wages", align: "center" },
  { label: "Vehicles", align: "center" },
  { label: "", align: "center" },
  { label: "Fuel", align: "center" },
];

export const leadChargesFields = [
  // {
  //   id: "typeName",
  //   type: "staticText",
  // },
  {
    id: "typeName",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "provisionalDate",
    type: "staticText",
    width: "120px",
  },
  {
    id: "price",
    placeholder: "Charge",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "driverQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "porterQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "packerQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "wageCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vehicleTypeId",
    placeholder: "",
    type: "select",
    width: "100px",
  },
  {
    id: "vehicleQty",
    placeholder: "Qty",
    type: "text",
    width: "35px",
    inputProps: {
      maxLength: 2,
    },
    // disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "fuelCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadCostHeading: TableHeading[] = [
  { label: "Drivers" },
  { label: "Porters", align: "left" },
  { label: "Packers", align: "left" },
  { label: "Wages", align: "center" },
  { label: "Vehicles", align: "center" },
  { label: "", align: "center" },
  { label: "Fuel", align: "center" },
];

export const leadCostFields = [
  {
    id: "driverQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "porterQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "packerQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "wageCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vehicleTypeId",
    placeholder: "",
    type: "select",
    width: "100px",
  },
  {
    id: "vehicleQty",
    placeholder: "Qty",
    type: "text",
    width: "35px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "fuelCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadMaterialsHeading: TableHeading[] = [
  { label: "Materials" },
  { label: "Surveyed Qty", align: "left" },
  { label: "Charge Qty", align: "left" },
  { label: "Rate", align: "center" },
  { label: "Total", align: "center" },
  { label: "Volume", align: "center" },
  { label: "Cost", align: "center" },
];

export const leadMaterialsFields = [
  {
    id: "name",
    type: "staticText",
  },
  {
    id: "surveyedQty",
    placeHolder: "",
    type: "text",
    width: "100px",
    disabled: true,
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "chargeQty",
    placeHolder: "",
    type: "text",
    width: "100px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "total",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "volume",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "cost",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadGenInfoHeading: TableHeading[] = [
  { label: "General Information" },
  { label: "", align: "left" },
];

export const leadGenInfoFields = [
  {
    id: "generalInformation",
    type: "staticText",
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadGenInoList = [
  { generalInformation: "Driver wage", price: "", id: "driverWage" },
  { generalInformation: "Porter wage", price: "", id: "porterWage" },
  { generalInformation: "Packer wage", price: "", id: "packerWage" },
  // { generalInformation: "Contents Value", price: "", id: "contentsValue" },
];

export const leadAncillariesHeading: TableHeading[] = [
  { label: "Ancillaries" },
  { label: "", align: "left" },
  { label: "Chargeable" },
];

export const leadAncillariesFields = [
  // {
  //   id: "name",
  //   type: "staticText",
  // },
  {
    id: "name",
    placeHolder: "",
    type: "text",
    width: "60px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "charge",
    placeHolder: "",
    type: "text",
    width: "60px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "isChargeable",
    placeHolder: "",
    type: "checkbox",
    width: "40px",
  },
];

export const leadAncillariesList = [
  { ancillaries: "Tolls", price: "", charageable: false },
  { ancillaries: "Ferry charges", price: "", charageable: false },
  { ancillaries: "", price: "", charageable: false },
];

export const leadQuoteSubcontractorHeading: TableHeading[] = [
  { label: "Subcontractor" },
  { label: "Name", align: "left" },
  { label: "Charge", align: "left" },
];

export const leadQuoteSubcontractorFields = [
  {
    id: "subContractorId",
    placeHolder: "",
    type: "select",
    width: "200px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "name",
    placeHolder: "",
    type: "text",
    width: "180px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    disabled: (row: any) => !row?.subContractorId,
  },
  {
    id: "chargeAmount",
    placeHolder: "",
    type: "text",
    width: "100px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
    disabled: (row: any) => !row?.subContractorId,
  },
];

export const leadEstimateFinalFields = [
  {
    label: "Content :",
    type: "title",
    md: 1.5,
  },
  {
    id: "contentValue",
    label: {
      quotation: "Content Value",
      estimate: "Content Value",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    // disabled: true,
    inSingleGridForm: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  // {
  //   id: "accepted_status",
  //   label: {
  //     quotation: "Status",
  //     estimate: "Status",
  //   },
  //   placeHolder: "",
  //   type: "text",
  //   md: 2,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   disabled: true,
  //   inSingleGridForm: true,
  // },
  {
    label: "",
    type: "title",
    md: 8.5,
  },
  {
    label: "Amount :",
    type: "title",
    md: 1.5,
  },
  {
    id: "quoteTotal",
    label: {
      quotation: "Quote Total",
      estimate: "Total",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    inSingleGridForm: true,
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },

  {
    id: "costTotal",
    label: {
      quotation: "Total Cost",
      estimate: "Total Cost",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    inSingleGridForm: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
     id: "amountSpacer",
    label: "",
    type: "title",
    md: 6.5,
  },
  {
    label: "Expiry :",
    type: "title",
    md: 1.5,
  },
  {
    id: "quoteExpiresOn",
    label: {
      quotation: "Quote Expires On",
      estimate: "Estimate Expires On",
    },
    placeHolder: "",
    type: "date",
    disablePast: true,
    inSingleGridForm: true,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
 {
    id: "profit",
    label: {
      quotation: "Profit (%)",
      estimate: "Profit (%)",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    inSingleGridForm: true,
    valueFormat: "price",
    // prefixIcon: "£",
    patternAllowed: patternConstant?.PERCENTAGE,
  },
];

export const leadEstimateInsuranceGeneralFields = [
  {
    id: "insurancePercentage",
    label: "Insurance (%)",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PERCENTAGE,
  },
];
export const leadEstimateInsuranceFields = [
  {
    id: "insuranceAmount",
    label: "Insurance Amount",
    placeHolder: "",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    disabled: false,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "insuranceType",
    label: "Insurance Type",
    placeHolder: "",
    type: "select",
    options: [
      "Move Price",
      "Contents",
      "Pack Price",
      "In to store",
      "From store",
      "Fixed",
      "Bronze Ext Liability",
      "Silver Ext Liability",
      "Gold Ext Liability",
    ],
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const leadEstimateNoteFields = [
  {
    id: "notes",
    label: "Customer Notes",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const leadQuoteNoteFields = [
  {
    id: "notes",
    label: "Customer Notes (Internal)",
    tooltipText: "Customer Notes (Internal)",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "transportnote",
    label: "Transport Notes (Internal)",
    tooltipText: "Transport Notes (Internal)",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "quotenote",
    label: "Quote Note (for customers)",
    tooltipText: "Quote Note (for customers)",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];
export const leadLogsFields = [
  {
    id: "action",
    title: "Input",
    placeHolder: "Insert text",
    type: "text",
    md: 5,
    isMandatory: true,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "action_type",
    title: "Stage",
    placeHolder: "Select",
    type: "select",
    options: ["NEW LEAD", "ESTIMATES", "SURVEY", "QUOTE", "CONFIRMED"],
    md: 4,
  },
];

export const LEAD_LOG_STARTER_FIELD = [
  {
    id: "action",
    title: "Input",
    placeHolder: "Insert text",
    type: "text",
    md: 5,
    isMandatory: true,
    inputProps: {
      maxLength: 150,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "action_type",
    title: "Stage",
    placeHolder: "Select",
    type: "select",
    options: [
      "NEW LEAD",
      "ESTIMATES",
      "SURVEY",
      "QUOTE",
      "CONFIRMED",
      "ARCHIVED",
      "LOST",
      "DISPUTE",
      "STORAGE ENQ",
      "STORAGE",
      "DEBTOR",
      "EXTERNAL",
    ],
    md: 2.5,
  },
  {
    id: "status_change_reason",
    title: "Reason",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 2.5,
  },
];

// Dynamic getter for leadEstimateFinalFields with hideQuoteTotal logic
export function getLeadEstimateFinalFields({ hideQuoteTotal = false } = {}) {
  const fields = [...leadEstimateFinalFields];
  // If quoteTotal is hidden, set the md of the blank title to 8.5 (6.5 + 2) and remove quoteTotal
  if (hideQuoteTotal) {
    const blankTitleIdx = fields.findIndex(
      (f) => f.type === "title" && f.label === "" && f.id === "amountSpacer"
    );
    if (blankTitleIdx !== -1) {
      fields[blankTitleIdx].md = 8.5;
    }
    // Remove quoteTotal field
    const quoteTotalIdx = fields.findIndex((f) => f.id === "quoteTotal");
    if (quoteTotalIdx !== -1) {
      fields.splice(quoteTotalIdx, 1);
    }
  }
  return fields;
}
